import { Paper, useTheme } from '@mui/material';
import React, { ReactNode } from 'react';

export const CodeServiceButton = (props: { children: ReactNode; selected: boolean; onClick: () => void }) => {
  const theme = useTheme();
  const { children, selected = false, onClick = () => {} } = props;

  return (
    <Paper
      elevation={0}
      sx={{
        minHeight: 100,
        color: selected ? 'white' : 'default',
        backgroundColor: selected ? theme.palette.primary.main : theme.palette.primary.contrastText,
        p: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        height: '100%',
      }}
      onClick={() => onClick()}
    >
      {children}
    </Paper>
  );
};
